// extracted by mini-css-extract-plugin
export default {"generic-label-style":"styles_generic-label-style__YLCAA"};